import * as Sentry from "@sentry/react";
import { getAllApiDomains } from "@/utils/regionApi";
import React from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";

let initialised = false;

export const closeSentry = () => {
  if (!initialised) {
    return;
  }
  void Sentry.close();
  initialised = false;
};

export const initSentry = () => {
  if (initialised) {
    return;
  }
  if (import.meta.env.VITE_ENABLE_SENTRY !== "true") {
    return;
  }
  initialised = true;

  const sentryProjectName = import.meta.env.VITE_SENTRY_PROJECT_NAME ?? "mesh-editor";
  const sentryRelease = import.meta.env.VITE_SENTRY_RELEASE_VERSION
    ? `${sentryProjectName}@${import.meta.env.VITE_SENTRY_RELEASE_VERSION}`
    : undefined;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        blockAllMedia: true,
        maskAllText: true
      }),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      })
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: getAllApiDomains(),
    profilesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: sentryRelease,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    debug: import.meta.env.NODE_ENV === "development",
    enabled: true
  });
};
